import { createSelector } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Loading from '../../../../common/components/loading/Loading';
import { ContentClass } from '../../../../common/enums/ContentClasses';
import { ContentType } from '../../../../common/enums/ContentTypes';
import { useDispatch } from '../../../../common/store/store';
import ContentDetailsTable from '../../../components/contentDetailsTable/ContentDetailsTable';
import CreatorDetailsTable from '../../../components/creatorDetailsTable/CreatorDetailsTable';
import Preview from '../../../components/preview/Preview';
import BatchActionButtons from '../../../containers/batchActionButtons/BatchActionButtons';
import BatchContentList from '../../../containers/batchContentList/BatchContentList';
import SingleItemEdit from '../../../containers/singleItemEdit/SingleItemEdit';
import { makeClaimBatchRequest } from '../../../store/batch/batch.actions';
import {
  selectBatchClaimed,
  selectContributor,
  selectCurrentStockItem,
  selectIsBatchLoading,
  selectVisibleStockItems,
} from '../../../store/batch/batch.selectors';
import { makeGroupsRequest } from '../../../store/groups/groups.action';
import { makeRejectReasonsRequest } from '../../../store/rejectionReason/rejectionReason.actions';

function VR360Review(): JSX.Element {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(makeClaimBatchRequest([ContentType.VR_360]));
    dispatch(makeRejectReasonsRequest());
    dispatch(makeGroupsRequest(ContentClass.video));
  }, [dispatch]);

  const { batchClaimed, isBatchLoading, contributor, currentStockItem, visibleStockItems } = useSelector(selector);

  // As this app grows we should create a more sophisticated loading
  // scheme
  if (isBatchLoading || !batchClaimed) {
    return <Loading isBatchLoading={isBatchLoading} />;
  }

  return (
    <div className="grid grid-cols-12 gap-6 videoBatch">
      <div className="col-span-12 md:col-span-5 flex flex-col">
        {contributor && <CreatorDetailsTable creator={contributor} contentClass={ContentClass.video} />}
        <ContentDetailsTable stockItem={currentStockItem} />
        <div className="mt-4">
          <Preview stockItem={currentStockItem} />
        </div>
        <BatchActionButtons contentTypes={[ContentType.VR_360]} visibleStockItems={visibleStockItems} />
        <BatchContentList contentClass={ContentClass.video} columnsPerRow={4} visibleStockItems={visibleStockItems} />
      </div>
      <div className="col-span-12 md:col-span-7 flex flex-col">
        <div className="p-6 bg-white">
          <SingleItemEdit contentClass={ContentClass.video} allowedContentTypes={[ContentType.VR_360]} />
        </div>
      </div>
    </div>
  );
}
export default VR360Review;

const selector = createSelector(
  [selectBatchClaimed, selectIsBatchLoading, selectContributor, selectCurrentStockItem, selectVisibleStockItems],
  (batchClaimed, isBatchLoading, contributor, currentStockItem, visibleStockItems) => ({
    batchClaimed,
    isBatchLoading,
    contributor,
    currentStockItem,
    visibleStockItems,
  })
);
